// extracted by mini-css-extract-plugin
export default {"topToBtm":"BtnScrollUp_topToBtm__wspAs","iconPosition":"BtnScrollUp_iconPosition__46a4E","iconStyle":"BtnScrollUp_iconStyle__BYGXo","movebtn":"BtnScrollUp_movebtn__v+9XI"};